import RangeLength from "$src/CGS/domain/dto/core/Length/RangeLength";
import { ApplianceApertureIdentifier } from "$src/CGS/domain/dto/core/bones/ApplianceApertureIdentifier";
import { BoneObject } from "./BoneObject";

export class ApplianceApertureBoneObject extends BoneObject {

    ApertureIdentifier?: ApplianceApertureIdentifier;
    PossibleHeight?: RangeLength;
}